import { ClipboardList } from 'lucide-react';
import MigracionAsistente from '../importador/MigracionAsistente';

/* =====================================================================
   Las pantallas del carril `importador` · Programa Resguardo U-04
   =====================================================================
   «Pasar mi inventario a TEGO» (DISEÑO-U-04 §6). En a1 la ruta abría
   directamente la revisión fila por fila; desde a2 abre el asistente de
   seis pasos, con el MISMO id `migracion` (nadie que la tenga guardada
   pierde el camino), y la revisión y la captura se abren desde él.

   MISMO PERMISO Y ROL MÍNIMO QUE «Traer mis datos» (`importar`, ADMIN,
   solo empresa): son dos maneras de traer lo mismo, y las llaves
   estrechas del importador se exigen dentro, en el servidor.
   ===================================================================== */
export default {
  orden: 45,
  grupos: [{
    grupo: 'Administración',
    items: [
      { id: 'migracion', etiqueta: 'Pasar mi inventario a TEGO', icono: ClipboardList, permiso: 'importar', min: 'ADMIN', soloEmpresa: true, Comp: MigracionAsistente },
    ],
  }],
};
